module.exports = __webpack_public_path__ + "img/287.2b3bb922.png";